import React  from 'react';
import { Link } from 'react-router-dom';
import "contents/assets/scss/page/member.scss";

function SearchPw() {
  return (
    <main className='com_member p_searchPw'>
      <div className='box'>
        <h2 className='title'>비밀번호 찾기</h2>
        <ul className='com_input_sec'>
          <li className='tit_field'>아이디</li>
          <li className='input_field'><input type='text' placeholder='회원 아이디(이메일) 입력'/></li>
          <li className='tit_field'>전화번호 인증하기</li>
          <li className='input_field'>
            <div className="com_input_wrap flex_row">
              <input type='text' placeholder='-없이 전화번호 입력'/>
              <button className="com_btn gray m">인증번호 요청</button>
            </div>
            <span className="error_txt">* 전화번호 형식이 정확하지 않습니다.</span>
          </li>
          <li className='tit_field'>발송된 인증번호를 입력해 주세요.</li>
          <li className='input_field'>
            <div className="com_input_wrap flex_row">
              <input type='text' placeholder='인증번호 입력'/>
              <button className="com_btn gray m">확인</button>
            </div>
            <span className="error_txt">* 인증번호가 정확하지 않습니다.</span>
          </li>
        </ul>
        <div className="txt_box">
          등록하신 전화번호로 신규 비밀번호를<br />보내 드렸습니다.
        </div>
        <section className='com_btn_wrap'>
          <Link to="/Member/Login" className='com_btn orange m bold'>로그인 페이지 이동하기</Link>
        </section>
      </div>
    </main>
  );
}

export default SearchPw;
